<template>
    <modal ref="modal">
        <ListView
            :inline="true"
            ref="list"
            title="Choose folder"
            :show-id="false"
            :api-paging="false"
            :api-search="false"
            :api-list="apiList"
            :columns="columns"
            use-folders>
            <template v-slot:custom="props">
                <slot name="custom" v-bind="props"></slot>
            </template>
            <template v-slot:actions="{ currentFolder }">
                <button class="btn btn-primary" @click="close(currentFolder)">Select</button>
            </template>
        </ListView>
    </modal>
</template>
<script>
import ListView from "@/views/templates/ListView.vue";

export default {
    components: { ListView },
    props: {
        apiList: {
            type: Function,
            required: true
        },
        columns: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            callback: null
        };
    },
    methods: {
        open(callback) {
            this.callback = callback;
            this.$refs.modal.open();
        },
        close(folder) {
            if (this.callback) {
                this.callback(folder, () => {
                    this.$refs.modal.close();
                });
            } else {
                this.$refs.modal.close();
            }
        }
    }
};
</script>
